<template>
  <div>
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'ServiceMain',
    data() {
      return {
      }
    },

    mounted() {
    },

    created() {
      // if (window.location.protocol !== 'https:') window.location.href.replace('https:','https:')
      // if (window.location.protocol !== 'https:') this.doRedirect()
    },
    computed: {
    },

    methods: {
      // doRedirect() {
      //     this.$router.push({
      //         name: 'ServiceMain'
      //     })
      // },
    }
  }
</script>
<style>

</style>
